import type { EbookQuestion } from '@wx-weiqi/contracts';
import { boardCoordinate, stoneRadius } from '../domain/board-geometry';
import type { savedNextMoves } from '../services/ebook-variations';

export function EbookBranchTrails({
  size,
  stones,
  moves,
}: {
  size: EbookQuestion['size'];
  stones: EbookQuestion['stones'];
  moves: ReturnType<typeof savedNextMoves>;
}) {
  return (
    <g
      className="ebook-branch-trails"
      role="img"
      aria-label="已保存分支下一手提示"
      pointerEvents="none"
    >
      {moves
        .filter(({ point }) => stones[point.y * size + point.x] === null)
        .map(({ point, outcome }) => (
          <circle
            key={`${point.x}:${point.y}`}
            className="ebook-trail-point"
            data-point={`${point.x}:${point.y}`}
            data-outcome={outcome}
            cx={boardCoordinate(size, point.x)}
            cy={boardCoordinate(size, point.y)}
            r={stoneRadius(size) * 0.48}
            fill={outcome === 'CORRECT' ? '#167042' : '#bd3434'}
          >
            <title>
              {outcome === 'CORRECT' ? '下一手：有已保存的正确变化' : '下一手：已保存的错误变化'}
            </title>
          </circle>
        ))}
    </g>
  );
}
